import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';

interface Props {
  showRisks: boolean;
  useWhatsapp?: string;
  whatsAppPhoneNumber?: string;
  riskList?: string[];
}

function WhatsApp({ showRisks, useWhatsapp, whatsAppPhoneNumber, riskList = [] }: Props) {
  const getValue = () => {
    if (useWhatsapp?.toLowerCase() === 'different') {
      return whatsAppPhoneNumber;
    }
    return useWhatsapp?.toLowerCase() === 'no' ? 'No' : 'Yes, with the same number';
  };
  const label = whatsAppPhoneNumber ? 'Alternative Phone Number' : 'Uses WhatsApp';
  return (
    <SummaryRow
      key="useWhatsApp"
      label={label}
      fullLabel="Do you use WhatsApp?"
      value={getValue()}
      isRisk={showRisks && riskList.includes(Q.USE_WHATSAPP)}
    />
  );
}

export default WhatsApp;
